import { createFileRoute } from '@tanstack/react-router';
import { CrmHelpdeskAiContentPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/prompts/new')({
  component: ContentCreateRoute,
});
function ContentCreateRoute() {
  const { locale } = Route.useParams();
  return (
    <CrmHelpdeskAiContentPage locale={locale} kind="prompts" create search={Route.useSearch()} />
  );
}
